/**
 * @generated SignedSource<<368318a70ad99817ba66921994137f3f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedFiltersModal_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "DurationBasedFiltersModal_session";
};
export type DurationBasedFiltersModal_session$key = {
  readonly " $data"?: DurationBasedFiltersModal_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedFiltersModal_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedFiltersModal_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "0e28b16d9a8e47aeee09ba1824741a48";

export default node;
